module.exports = __webpack_public_path__ + "static/media/logo-twitter-white.d12fb471.svg";